
const target = '.js-text-animation';

const txtblinking = (el) => {
  const txtblinkingTargets = el.querySelectorAll('.txtblinking-el');
    if (txtblinkingTargets.length) {
      txtblinkingTargets.forEach(txtblinkingTarget => {
        txtblinkingTarget.innerHTML = txtblinkingTarget.textContent.split('').map(letter => {
            const baseDelay = parseInt(txtblinkingTarget.dataset.delay) || 1000;
            const randomDelay = Math.floor(Math.random() * (baseDelay + 1));
            console.log(`ベース遅延: ${baseDelay}, ランダム遅延: ${randomDelay}`);
            return `<span class="txtblinking" style="animation-delay: ${randomDelay}ms">${letter}</span>`;
        }).join('');
      });
    }
};

const observerMethod = (el) => {
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-active');
            } 
            // else {
            //     entry.target.classList.remove('is-active');
            // }
        });
    }, {
        threshold: 0.1,
    });
    el.querySelectorAll('.text-animation').forEach(el => {
        observer.observe(el);
    });
};

const textAnimations = () => {  
  Array.from(document.querySelectorAll(target)).forEach(el => {
    txtblinking(el);
    observerMethod(el);
  });
};

export { textAnimations };